import '@chewy/kib-truncation-styles/dist/kib-truncation.css';

import { KibProductRating } from '@chewy/kib-product-react';
import {
  KibTruncation,
  KibTruncationContent,
  KibTruncationToggle,
} from '@chewy/kib-truncation-react';
import { RefObject } from 'react';

import styles from './styles.module.scss';

import { FreshProductReviewFragment } from '@/integrations/chewy-api/__generated__/chewy-api.fresh-products';

const REVIEW_TEXT_TRUNCATE_LENGTH = 300;

const formatReviewDate = (review: FreshProductReviewFragment) => {
  const reviewDate = new Date(review?.submittedAt || '');
  return reviewDate.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'America/New_York',
  });
};

type ReviewProps = {
  review: FreshProductReviewFragment;
  isNew: boolean;
  focusRef: RefObject<HTMLDivElement>;
};

export const Review = ({ review, isNew, focusRef }: ReviewProps) => {
  const reviewText = review?.reviewText ?? '';
  const shouldTruncate = reviewText.length > REVIEW_TEXT_TRUNCATE_LENGTH;
  const initialReviewText = `${reviewText.slice(0, REVIEW_TEXT_TRUNCATE_LENGTH)}...`;

  return (
    <div className={styles.review}>
      <KibProductRating
        className={styles.rating}
        rating={review?.rating || 0}
        ref={isNew ? focusRef : undefined}
        tabIndex={-1}
      />
      <h3 className={styles.reviewTitle}>{review?.title || ''}</h3>
      <div className={styles.reviewMetaData}>
        <span>
          By <strong>{review?.submittedBy || ''}</strong> on {formatReviewDate(review)}
        </span>
        {review?.isIncentivized && (
          <div className={styles.incentiveBadge}>
            <span>Received Free Product</span>
          </div>
        )}
      </div>
      {shouldTruncate ? (
        <KibTruncation>
          <KibTruncationContent
            className={styles.truncationContent}
            summary={<p>{initialReviewText}</p>}
          >
            <p>{reviewText}</p>
          </KibTruncationContent>
          <KibTruncationToggle />
        </KibTruncation>
      ) : (
        <p>{reviewText}</p>
      )}
    </div>
  );
};
